import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Menu } from '../menu/menu';
import { About } from '../about/about';
import { ContentService, SiteContentHome } from '../../services/content.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-home',
  imports: [CommonModule, RouterModule, Menu, About],
  templateUrl: './home.html',
  styleUrl: './home.scss',
})
export class Home implements OnInit {
  content$!: Observable<any>;

  constructor(private contentService: ContentService) {}

  ngOnInit() {
    this.content$ = this.contentService.getHomeContent().pipe(
      map(content => {
        if (content && content.heroImages && content.heroImages.length > 0) {
          const imgs = content.heroImages;
          const normalized = [];
          for (let i = 0; i < 4; i++) {
            normalized.push(imgs[i % imgs.length]);
          }
          content.heroImages = normalized;
        }
        return content;
      })
    );
  }

  absoluteUrl(path?: string | null): string {
    if (!path) return '';
    return path.startsWith('http') ? path : 'https://dev.thehuskbakery.com/' + path;
  }
}
